import { FC } from 'react'

import { SpotifyGenresModal } from '../SpotifyGenresModal'

export const GenresModalsWrapper: FC = () => <SpotifyGenresModal />
